import React from 'preact/compat';
import Cross from '../../assets/cross';
import styles from './modalWrapper.module.scss'

function ModalWrapper(props: IModalWrapper) {

    const closeButtonRef = React.createRef<HTMLDivElement>();
    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            props.onKeyClose();
        }
    }
    if (!props.isOpen) {
        return null;
    }

    return (
        <>
            <div className={styles.modal} group modal>
                <div className={styles.modal_container}>
                    <div className={styles.modal_content}>
                        <div className={styles.modal_header}>
                            <div className={styles.modal_title}>
                                <div className={styles.title} dangerouslySetInnerHTML={{ __html: props.title }} />
                                {
                                    props.subtitle &&
                                    <div
                                        className={styles.subtitle}
                                        dangerouslySetInnerHTML={{ __html: props.subtitle }}
                                    />
                                }
                            </div>

                            <div className={styles.close_button} data-testid='close_button_header'
                                data-semantic-id='close_button_header'
                                onClick={props.onClose}
                                onKeyDown={handleKeyPress}
                                ref={closeButtonRef}
                                focusable
                            >
                                <Cross />
                            </div>
                        </div>
                        <div className={styles.modal_body}>
                            {props.content}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalWrapper;

interface IModalWrapper {
    isOpen: boolean;
    title: string;
    subtitle?: string;
    content: React.ReactNode;
    onClose();
    onKeyClose();
}

